'use strict';

angular.module('app.advertiserProjectDetail', [])

.controller('advertiserProjectDetailCtrl', function ($scope, $rootScope, $http, $log, $location, $compile, $modalInstance, $modal, projectData, mentionData, advertiserProjectDetailService, TRACK_EVENTS) {

        $scope.isNewProject = projectData == null ? true : false;
        var definitions = angular.copy($rootScope.definitions);
        var allowAddingTag = true;
        var newTagLabel = "";
        var language_id = null;
        var checkLanguage = -1;
        var closeDropdownList = true;

        $scope.KeywordValidate = true;
        $scope.project = {};
        
        $scope.newProjectDateOpts = {
            format: 'MMM D, YYYY'
        }
        $scope.newMentionList = [];
        $scope.existsMentions = [];
        $scope.temporaryMentions = [];

        $scope.searchCountries = function(event) {
            if (/[a-zA-Z0-9-_ ]/.test(event.key)) {
                for(var i = 0; i < $scope.countryListData.length; i++) {
                    if($scope.countryListData[i].name.toLowerCase().indexOf(event.key.toLowerCase()) == 0) {
                        var checkbox = $("#selectCountryDD > .checkboxLayer.show .checkBoxContainer")
                        var item = checkbox.find('label')[i];
                        checkbox.animate({ scrollTop: item.parentElement.parentElement.offsetTop }, { duration: 'medium', easing: 'swing' });
                        break;
                    }
                }
            }
        }

        $scope.countryListData = [];
        angular.forEach(definitions.countries, function(country) {
            if(country.isActive == 1) {
                $scope.countryListData.push(country);
            }
        })

        $scope.deletedMention = [];

        $scope.addNewProjectSelectCountry = function (data) {
            $("#selectCountryDD button.multiSelectButton").css('background-color', "white");
        }

        $scope.unexistingClick = function(tagToDefine, $event) {
            var getLanguageByCountryParam = {
                countries: $scope.countryList
            }

            advertiserProjectDetailService.getLanguageByCountry(getLanguageByCountryParam)
                .then(function(response) {
                    if (response.data.language.length == 1) {
                        language_id = response.data.language[0].id;
                    }
                    else if (response.data.language.length > 1 && $scope.countryList.length === 1) {
                        language_id = response.data.language.map( function(item) {
                            return item.id;
                        })
                    }
                    else if (response.data.language.length > 1) {
                        language_id = -1;
                    }

                    var unexistingMention = $event.target;
                    var typeid = $event.target.parentElement.parentElement.getAttribute("data-typeid");
                    var tagElement = unexistingMention.parentElement;
                    $rootScope.newMentionModalHandler(tagToDefine, typeid, language_id, function(newMention){
                        if(newMention){
                            var newSpan = $compile('<span class="txt-waitapprove">+ Wait For Approve&nbsp;</span><img src="/images/question.gif" class="questionMention">')($scope);
                            $(tagElement).find('.unexisting').remove();
                            $(tagElement).find('.questionMention').remove();
                            $(tagElement).append(newSpan);
                            $scope.existsMentions.push(newMention);
                        } else {
                            console.log('cancel');
                        }
                            
                    });
                }, function(response) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = response.message;
                })
        };
        
        setTimeout(function () {
            $(".mentions").tagit({
                allowDuplicates: false,
                allowSpaces: true,
                removeConfirmation: true,
                caseSensitive: false,
                // tagLimit: 3,
                //availableTags: availableTags(),

                beforeTagAdded: function (event, ui) {
                    var label = encodeURIComponent(ui.tagLabel);
                    var typeid = event.target.getAttribute("data-typeid");
                    if($scope.KeywordValidate){
                        var DomainPatter = new RegExp(/^(?!:\/\/)([a-zA-Z0-9]+\.)?[a-zA-Z0-9-]+\.([a-zA-Z]{2,6}|[a-zA-Z]{2,6}.[a-zA-Z]{2,6})?$/i);
                        if(typeid == 1){
                            // if(DomainPatter.test(ui.tagLabel) || ui.tagLabel.startsWith("#"))
                            if ($scope.countryList == [] || $scope.countryList === undefined || $scope.countryList.length == 0) {
                                $('#projectKeywords').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Please select country first</div>', html: true});
                                $('#projectKeywords').popover('show');
                                event.stopPropagation();
                                return false;
                            }

                            if(DomainPatter.test(ui.tagLabel) || ui.tagLabel.indexOf("#") == 0 || ui.tagLabel.split(' ').length >= 3)
                            {
                                $('#projectKeywords').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Keyword is not valid,should input only 1 or 2 words and not be URL or Hashtag(#)</div>', html: true});
                                $('#projectKeywords').popover('show');
                                event.stopPropagation();
                                return false;
                            }
                            $('#projectKeywords').popover('destroy');
                        } else if(typeid == 2){
                            if ($scope.countryList == [] || $scope.countryList === undefined || $scope.countryList.length == 0) {
                                $('#projectUrls').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Please select country first</div>', html: true});
                                $('#projectUrls').popover('show');
                                event.stopPropagation();
                                return false;
                            }

                            if(!DomainPatter.test(ui.tagLabel))
                            {
                                $('#projectUrls').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Url is not valid - i.e. google.com</div>', html: true});
                                $('#projectUrls').popover('show');
                                event.stopPropagation();
                                return false;
                            }
                            $('#projectUrls').popover('destroy');
                        }  else if(typeid == 3){
                            if ($scope.countryList == [] || $scope.countryList === undefined || $scope.countryList.length == 0) {
                                $('#projectHashtags').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Please select country first</div>', html: true});
                                $('#projectHashtags').popover('show');
                                event.stopPropagation();
                                return false;
                            }

                            // if(!ui.tagLabel.startsWith("#"))
                            if(ui.tagLabel.indexOf("#") != 0)
                            {
                                $('#projectHashtags').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Hashtag is not valid, should begin with #!</div>', html: true});
                                $('#projectHashtags').popover('show');
                                event.stopPropagation();
                                return false;
                            }
                            $('#projectHashtags').popover('destroy');
                        } 
                    }
                    return true;
                },
                onTagClicked: function (event, ui) {
                },
                afterTagAdded: function (event, ui) {
                    var isNewTag = false;
                    var id = 0;
                    var label = ui.tagLabel;

                    var checkMentionAfterTagAddedParam = {
                        keyword: label,
                        countries: $scope.countryList
                    }

                    var requestAfterTagAdded = {
                        url: $rootScope.apiUrl + 'mention/exists',
                        method: 'POST',
                        data: JSON.stringify(checkMentionAfterTagAddedParam)
                    }

                    $http(requestAfterTagAdded).success(function (response) {
                        var typeid = event.target.getAttribute("data-typeid");
                        if (response.data.checkLanguage == -2) {
                            if (typeid == 1) {
                                $("#projectKeywords").tagit("removeTagByLabel", ui.tagLabel);
                                $('#projectKeywords').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Only include Brand names when multiple coutries selected</div>', html: true});
                                $('#projectKeywords').popover('show');
                                event.stopPropagation();
                                return false;
                            } else if (typeid == 2) {
                                $("#projectUrls").tagit("removeTagByLabel", ui.tagLabel);
                                $('#projectUrls').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Only include Brand names when multiple coutries selected</div>', html: true});
                                $('#projectUrls').popover('show');
                                event.stopPropagation();
                                return false;                              
                            } else {
                                $("#projectHashtags").tagit("removeTagByLabel", ui.tagLabel);
                                $('#projectHashtags').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Only include Brand names when multiple coutries selected</div>', html: true});
                                $('#projectHashtags').popover('show');
                                event.stopPropagation();
                                return false;                                
                            }
                            return;
                        }

                        id = response.data.keyword.id;
                        if (id == null) {
                            isNewTag = true;
                            newTagLabel = ui.tagLabel;
                            if (newTagLabel.indexOf('\'') >= 0) {
                                newTagLabel = newTagLabel.slice(0, newTagLabel.indexOf('\'')) + "\\" + newTagLabel.slice(newTagLabel.indexOf('\''));
                            }
                            var tempMention = {
                                id: null,
                                keywordType: typeid,
                                keyword: newTagLabel
                            }
                        } else if (id > 0) {
                            isNewTag = false;
                            ui.tag.children(".tagit-label").get(0).text = response.data.keyword.keyword;
                            var existMention = {
                                id: response.data.keyword.id,
                                keywordType: response.data.keyword.keywordType.id,
                                keyword: response.data.keyword.keyword
                            }
                            $scope.existsMentions.push(existMention);
                        }

                        if(isNewTag){
                            // var newMention = $compile('<a class="unexisting" role="button" ng-click="unexistingClick(\'' + ui.tagLabel + '\', $event)">+ New Mention&nbsp;</a><img src="/images/question.gif" class="questionMention">')($scope);
                            var newMention = $compile('<a class="unexisting" role="button" ng-click="unexistingClick(\'' + newTagLabel + '\', $event)">+ New Mention&nbsp;</a><img src="/images/question.gif" class="questionMention">')($scope);
                            newMention.insertBefore(ui.tag.children().last());
                        } else {
                            if(response.data.keyword.approved == 2){
                                var newMention = $compile('<span class="txt-waitapprove">+ Wait For Approve&nbsp;</span><img src="/images/question.gif" class="questionMention">')($scope);
                                newMention.insertBefore(ui.tag.children().last());
                            }
                        }
                    }).error(function (response) {
                        alert("We cannot get info about this keyword, please try again...")
                        console.log(response.data);
                    });
                },
                beforeTagRemoved: function(event, ui) {
                    
                },
                afterTagRemoved: function (event, ui) {
                    var delteIndex = -1;
                    $scope.existsMentions.forEach(function(val){
                        if(val.keyword == ui.tagLabel){
                            delteIndex = $scope.existsMentions.indexOf(val);
                        }
                    })
                    if(delteIndex != -1)
                    {
                        $scope.existsMentions.splice(delteIndex,1);
                    }
                }
            });
            
            if(!$scope.isNewProject){
                $scope.project = angular.copy(projectData);
                var url_getCurrentMentions = $rootScope.apiUrl + 'project/getCurrentMention/' + projectData.id;
                $http.get(url_getCurrentMentions, {loader: false}).
                    success(function (response) {
                        $scope.currentMentionList = response.data;
                        $scope.KeywordValidate = false;
                        $scope.currentMentionList.forEach(function(val){
                            if(val.keywordType.id == 1){
                                $("#projectKeywords").tagit("createTag", val.keyword);
                            }
                            if(val.keywordType.id == 2){
                                $("#projectUrls").tagit("createTag", val.keyword);
                            }
                            if(val.keywordType.id == 3){
                                $("#projectHashtags").tagit("createTag", val.keyword);
                            }
                        });
                        $scope.KeywordValidate = true;
                    }).error(function (response) {
                        alert("We cannot get info about this keyword, please try again...")
                        return false;
                });
                var url_getCountry = $rootScope.apiUrl + 'project/getCurrentCountry/' + projectData.id;
                $http.get(url_getCountry, {loader: false}).
                    success(function (response) {
                        $scope.countryListData.forEach(function (val) {
                            angular.forEach(response.data, function(item){
                                if(val.name == item.name){
                                    val.ticked = true;
                                }
                            })
                        });
                    }).error(function (response) {
                        alert("We cannot get info about this keyword, please try again...")
                        return false;
                });
            } else {
                if(mentionData != null) {
                    $scope.KeywordValidate = false;
                    var DomainPatter = new RegExp(/^(?!:\/\/)([a-zA-Z0-9]+\.)?[a-zA-Z0-9-]+\.([a-zA-Z]{2,6}|[a-zA-Z]{2,6}.[a-zA-Z]{2,6})?$/i);
                    mentionData.forEach(function(val){
                        if(val.startsWith("#")){
                            $("#projectHashtags").tagit("createTag", val);
                        } else if(DomainPatter.test(val)) {
                            $("#projectUrls").tagit("createTag", val);
                        } else {
                            $("#projectKeywords").tagit("createTag", val);
                        }
                    });
                    $scope.KeywordValidate = true;
                }
            }

            $scope.openDropdownList = function () {
                closeDropdownList = false;
            }

            $scope.closeDropdownList = function () {
                closeDropdownList = true;
                if (closeDropdownList == true) {
                    if ($scope.countryList == [] || $scope.countryList === undefined || $scope.countryList.length == 0) {
                        $('#projectKeywords').tagit("removeAll");
                        $('#projectUrls').tagit("removeAll");
                        $('#projectHashtags').tagit("removeAll");
                    }

                    $('#projectKeywords').popover('destroy');
                    $('#projectUrls').popover('destroy');
                    $('#projectHashtags').popover('destroy');

                    $scope.KeywordValidate = false;
                    $scope.temporaryMentions = [];
                    $scope.temporaryMentions.push($("#projectKeywords").tagit("assignedTags"));
                    $('#projectKeywords').tagit("removeAll");
                    angular.forEach($scope.temporaryMentions, function (temp) {
                        angular.forEach(temp, function (item) {
                            $("#projectKeywords").tagit("createTag", item);
                        })
                    })
                    $scope.KeywordValidate = true;

                    $scope.KeywordValidate = false;
                    $scope.temporaryMentions = [];
                    $scope.temporaryMentions.push($("#projectUrls").tagit("assignedTags"));
                    $('#projectUrls').tagit("removeAll");
                    angular.forEach($scope.temporaryMentions, function (temp) {
                        angular.forEach(temp, function (item) {
                            $("#projectUrls").tagit("createTag", item);
                        })
                    })
                    $scope.KeywordValidate = true;

                    $scope.KeywordValidate = false;
                    $scope.temporaryMentions = [];
                    $scope.temporaryMentions.push($("#projectHashtags").tagit("assignedTags"));
                    $('#projectHashtags').tagit("removeAll");
                    angular.forEach($scope.temporaryMentions, function (temp) {
                        angular.forEach(temp, function (item) {
                            $("#projectHashtags").tagit("createTag", item);
                        })
                    })
                    $scope.KeywordValidate = true;
                }
            }

            $scope.$watch('selectedCountry', function(newValue, oldValue){
                $scope.countryList = [];
                angular.forEach(newValue, function (item) {
                    $scope.countryList.push(item.id);
                })
            });
        }, 500);
        
        $scope.save = function (isValid) {

            $scope.selectedCountryId = [];
            $scope.countryListData.forEach(function (val) {
                if (val.ticked === true)
                    $scope.selectedCountryId.push(val.id)
            });

            if($("#newProjectForm").find(".unexisting").length > 0) {
                var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = "There are some New Mentions that does not exist in the system. Please help to create the New Mentions.";
                event.stopPropagation();
                return;
            } 
            
            // add project            
            var data = {
                name: $scope.project.name,
                keywords: $scope.existsMentions,
                countries: $scope.selectedCountryId,
                advertiserID: $rootScope.sideMenuSelections.advertiserId || null
            }

            var req = {
                url: $rootScope.apiUrl + 'project/newproject',
                method: 'POST',
                data: JSON.stringify(data)
            }

            $http(req).success(function (response) {
                // Mixpanel tracking create project
                analytics.track(
                    TRACK_EVENTS.CREATE_PROJECT.EVT_NAME,
                    {
                        "action": "Create",
                        "item": TRACK_EVENTS.CREATE_PROJECT.ITEM_NAME,
                        "target_type": TRACK_EVENTS.CREATE_PROJECT.ITEM_NAME,
                        "target_name": data.name,
                        "target_id": response.data.id,
                        "params": data
                    }
                );

                var newProjectData = {
                    id: response.data.id,
                    name: response.data.name,
                    projectKeywords: response.data.projectKeywords,
                    country: {
                        id: $scope.selectedCountryId
                    }
                };

                $rootScope.$broadcast('add_advertiserProjectList', { projectData : newProjectData});

                //close modal
                $modalInstance.close(function () {
                    $log.info('Close Modal now');
                })
            })
            .error(function (response) {
                var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = response.message;
            });
        }

        $scope.delete = function () {
            var req = {
                url: $rootScope.apiUrl + 'project/' + projectData.id,
                method: 'DELETE'
            }

            $http(req)
                .success(function (response) {
                    $scope.deleteConfirmModalInstance.close();
                    $modalInstance.close(function () {
                        $log.info('Close Modal now');
                    })
                    
                    $rootScope.$broadcast('delete_advertiserProjectList', { projectData : projectData});
                })
                .error(function (response) {
                    console.log("Failed to delete")
                })
        }

        $scope.update = function () {
            $scope.selectedCountryId = [];
            $scope.countryListData.forEach(function (val) {
                if (val.ticked === true)
                    $scope.selectedCountryId.push(val.id)
            });
            
            if($("#newProjectForm").find(".unexisting").length > 0) {
                var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = "There are some New Mentions that does not exist in the system. Please help to create the New Mentions.";
                event.stopPropagation();
                return;
            } 

            var data = {
                id: projectData.id,
                name: $scope.project.name,
                keywords: $scope.existsMentions,
                countries: $scope.selectedCountryId,
                advertiserID: $rootScope.sideMenuSelections.advertiserId || null
            }
            var req = {
                url: $rootScope.apiUrl + 'project/updateProject',
                data: JSON.stringify(data),
                method: 'POST'
            }

            $http(req)
                .success(function (response) {
                    $modalInstance.close(function () {
                        $log.info('Close Modal now');
                    })

                    $rootScope.$broadcast('update_advertiserProjectList', { projectData : response.data});
                })
                .error(function (response) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = response.message;
                })
        }

        $scope.deleteProjectConfirm = function () {
            var deleteConfirmModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/sideBarMenu/advertiserProjectList/advertiserProjectDetail/advertiserProjectDeleteConfirmation.html?app_v=deployDate'
            });
            $scope.deleteConfirmModalInstance = deleteConfirmModalInstance;
        }
    })